import { Component } from '@angular/core';

@Component({
  selector: 'uni-filters-buttons',
  templateUrl: './uni-filters-buttons.component.html',
  styleUrls: ['./uni-filters-buttons.component.scss'],
})
export class UniFiltersButtonsComponent {}
